/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable no-console */
import {
  BackgroundScriptMessageType,
  ContentScriptMessageType,
  SidePanelMessageType,
} from './extension.enums';
import {
  AnyBackgroundScriptMessage,
  AnyContentScriptMessage,
  AnySidePanelMessage,
  BackgroundScriptMessage,
  ContentScriptMessage,
  SidePanelMessage,
} from './messages.types';

export async function sendMessageToContentScript<
  T extends ContentScriptMessageType,
>(message: ContentScriptMessage<T>) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  let response: any = null;

  if (globalThis.ENVS.isFirefoxLike) {
    const tabs = await browser.tabs.query({
      active: true,
      currentWindow: true,
    });

    if (!tabs[0]?.id) {
      return null;
    }

    response = await browser.tabs.sendMessage(tabs[0].id!, message);
  } else if (chrome?.tabs?.sendMessage) {
    const tabs = await chrome.tabs.query({
      active: true,
      currentWindow: true,
    });

    if (!tabs[0]?.id) {
      return null;
    }

    response = await chrome.tabs.sendMessage(tabs[0].id!, message);
  }

  if (!response) {
    console.log(`Message "${message.type}" sent`);
  } else {
    console.log(`Message "${message.type}" sent with response: `, response);
  }

  return response;
}

export async function sendMessageToSidePanel<T extends SidePanelMessageType>(
  message: SidePanelMessage<T>
) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  let response: any = null;

  if (globalThis.ENVS.isFirefoxLike) {
    response = await browser.runtime.sendMessage(message);
  } else if (chrome?.runtime?.sendMessage) {
    response = await chrome.runtime.sendMessage(message);
  }

  if (!response) {
    console.log(`Message "${message.type}" sent`);
  } else {
    console.log(`Message "${message.type}" sent with response: `, response);
  }

  return response;
}

export async function sendMessageToBackground<
  T extends BackgroundScriptMessageType,
>(message: BackgroundScriptMessage<T>) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  let response: any = null;

  if (globalThis.ENVS.isFirefoxLike) {
    response = await browser.runtime.sendMessage(message);
  } else if (chrome?.runtime?.sendMessage) {
    response = await chrome.runtime.sendMessage(message);
  }

  if (!response) {
    console.log(`Message "${message.type}" sent`);
  } else {
    console.log(`Message "${message.type}" sent with response: `, response);
  }

  return response;
}

export function onMessage<
  T =
    | AnyContentScriptMessage
    | AnySidePanelMessage
    | AnyBackgroundScriptMessage,
>(
  callback: (
    message: T,
    sender: browser.runtime.MessageSender | chrome.runtime.MessageSender,
    sendResponse: (response?: T) => void
  ) => void
) {
  if (globalThis.ENVS.isFirefoxLike) {
    browser.runtime.onMessage.addListener(callback);
  } else if (chrome?.runtime?.onMessage) {
    chrome.runtime.onMessage.addListener(callback);
  }
}

export function removeOnMessage<
  T =
    | AnyContentScriptMessage
    | AnySidePanelMessage
    | AnyBackgroundScriptMessage,
>(
  callback: (
    message: T,
    sender: browser.runtime.MessageSender | chrome.runtime.MessageSender,
    sendResponse: (response?: T) => void
  ) => void
) {
  if (globalThis.ENVS.isFirefoxLike) {
    browser.runtime.onMessage.removeListener(callback);
  } else if (chrome?.runtime?.onMessage) {
    chrome.runtime.onMessage.removeListener(callback);
  }
}
